<div class="year-coverage" [class.year-coverage--cards]="!isRuler()">
  @for (year of yearViews(); track year.year) {
    <div class="statement-year">
      <div class="statement-year__head">
        <span class="statement-year__number">{{ year.year }}</span>
        <span [class]="year.badgeClass">
          <span class="statement-badge__dot"></span>{{ year.badge }}
        </span>
      </div>

      <div class="statement-year__body">
        @for (track of year.tracks; track track.documentType) {
          <div class="statement-track">
            <div class="statement-track__head">
              <span class="statement-track__label">{{ track.label }}</span>
              @if (track.annual) {
                <button
                  type="button"
                  class="statement-annual"
                  [class.statement-annual--selected]="track.annualSelected"
                  [class.statement-annual--missing]="track.annualMissing"
                  [class.statement-annual--sent]="track.annualSent"
                  [attr.aria-pressed]="track.annualSelected"
                  [title]="track.annualTitle"
                  (click)="
                    onDocumentPeriodClick(year.year, track.documentType, 1, 12, track.annual.files)
                  ">
                  Anual
                </button>
              } @else if (track.pendingPill) {
                <span class="statement-pending-pill">{{ track.pendingPill }}</span>
              }
            </div>

            <div
              class="statement-track__bar"
              role="group"
              [attr.aria-label]="'Meses cobertos — ' + track.label">
              @for (month of track.months; track month.month) {
                <button
                  type="button"
                  [class]="month.stateClass"
                  [class.statement-month--selected]="month.selected"
                  [attr.aria-pressed]="month.selected"
                  [title]="month.title"
                  (click)="onPeriodClick(year.year, track.documentType, month.month, month.month)">
                  <span class="statement-month__fill"></span>
                  <span class="statement-month__label">{{ month.label }}</span>
                </button>
              }
            </div>

            @if (track.periods.length) {
              <div class="statement-track__chips">
                @for (period of track.periods; track period.startMonth + '-' + period.endMonth) {
                  <button
                    type="button"
                    [class]="period.stateClass"
                    [class.statement-chip--selected]="period.selected"
                    [title]="period.title"
                    (click)="
                      onDocumentPeriodClick(
                        year.year,
                        track.documentType,
                        period.startMonth,
                        period.endMonth,
                        period.files
                      )
                    ">
                    {{ period.shortLabel }}
                  </button>
                }
              </div>
            }

            <span class="statement-track__complement">{{ track.complementLabel }}</span>

            @if (isSelectedTrack(year.year, track.documentType) && selectionTemplate()) {
              <div class="statement-track__selection">
                <ng-container [ngTemplateOutlet]="selectionTemplate()!" />
              </div>
            }
          </div>
        }

        @if (canUpload()) {
          <!-- Região viva **persistente**, por exercício: fica no DOM desde o início e só o texto
               muda. Uma região `aria-live` criada no mesmo instante do seu conteúdo costuma não ser
               anunciada pelos leitores de tela — era o caso de pôr o `role="status"` no próprio bloco
               de andamento, que nasce junto com a mensagem. O bloco visual abaixo não repete o
               `aria-live`, para o envio não ser anunciado duas vezes. -->
          <span class="visually-hidden" role="status" aria-live="polite">
            @if (isUploadingYear(year.year)) {
              Enviando {{ uploadProgress()!.fileName }}, arquivo {{ uploadProgress()!.index }} de
              {{ uploadProgress()!.total }}. A Cog AI está identificando o período e o tipo do
              documento.
            }
          </span>

          @if (isUploadingYear(year.year)) {
            <!-- Estado de andamento do envio, no lugar da área de arraste **deste** exercício. Existe
                 porque até 08/09/2026 o envio era mudo: o estado de carregamento só desabilitava o
                 input invisível, nenhum pixel mudava, e o usuário só sabia que tinha dado certo quando
                 o agente terminava — e no meio disso clicava de novo (bug 2895). -->
            <!-- Os handlers de arraste ficam aqui também, só para **cancelar** o evento: esta caixa
                 ocupa o lugar da área de envio, e é o alvo mais provável de um segundo arquivo. Sem
                 cancelar, o navegador abriria o arquivo solto e descarregaria a SPA no meio do
                 upload. -->
            <div
              class="statement-drop__uploading"
              (dragenter)="refuseDrag($event)"
              (dragover)="refuseDrag($event)"
              (drop)="refuseDrag($event)">
              <app-cog-loading-spinner [size]="18" aria-hidden="true" />
              <span class="statement-drop__uploading-title">
                Enviando {{ uploadProgress()!.fileName }}
              </span>
              <span class="statement-drop__uploading-hint">
                @if (uploadProgress()!.total > 1) {
                  arquivo {{ uploadProgress()!.index }} de {{ uploadProgress()!.total }} —
                }
                a Cog AI está identificando o período e se é DRE, balanço ou faturamento
              </span>
            </div>
          } @else {
            <div
              class="statement-drop"
              (dragenter)="onDragEnter($event, year.year)"
              (dragover)="onDragOver($event, year.year)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event, year.year)">
              <input
                type="file"
                class="statement-drop__input"
                multiple
                [id]="'statement-drop-' + year.year"
                [disabled]="isUploading()"
                (change)="onFilesSelected($event, year.year)" />
              <label
                class="statement-drop__label"
                [class.statement-drop__label--dragover]="dragOverYear() === year.year"
                [attr.for]="'statement-drop-' + year.year">
                <span class="statement-drop__icon" aria-hidden="true">⭱</span>
                <span class="statement-drop__title">Enviar documentos de {{ year.year }}</span>
                <span class="statement-drop__hint">
                  arraste o arquivo — a Cog AI identifica o período e se é DRE, balanço ou
                  faturamento
                </span>
              </label>
            </div>
          }
        } @else {
          <!-- Onboarding não iniciado (ou sem documento exigido configurado): o documento enviado por
               esta tela nasce como submissão do onboarding e precisa casar com um item do catálogo de
               documentos esperados, então sem processo não há contra o que casar. Só a área de envio some
               — a cobertura acima continua visível, porque não depende de onboarding. -->
          <div class="statement-upload-gate" role="status">
            <span class="statement-upload-gate__icon" aria-hidden="true">🔒</span>
            <span class="statement-upload-gate__title">Envio bloqueado para {{ year.year }}</span>
            <p class="statement-upload-gate__text">
              {{ uploadBlockReason() ?? 'O onboarding desta empresa ainda não foi iniciado.' }}
              O documento enviado nesta tela entra como documento do onboarding, por isso o
              onboarding precisa estar iniciado antes de enviar.
            </p>
            <button
              type="button"
              class="statement-upload-gate__cta"
              (click)="onboardingRequested.emit()">
              Ir para o onboarding
            </button>
          </div>
        }

        @if (year.classificationSummary) {
          <p class="statement-classification">
            <span aria-hidden="true">⚡</span>{{ year.classificationSummary }}
          </p>
        }
      </div>
    </div>
  }

  <div class="statement-legend">
    <span class="statement-legend__note">
      <strong>DRE e Balanço</strong>: só o anual é exigido — semestre, trimestre, mês e acumulado
      mostram o que já chegou e nunca aparecem como pendência. <strong>Faturamento</strong>: todo
      mês da janela é exigido, e mês sem documento é pendência.
    </span>
  </div>
</div>
